import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import api, { apiErr } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Kata sandi berhasil diubah. Silakan masuk.");
      navigate("/login");
    } catch (err) {
      toast.error(apiErr(err));
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 p-6">
      <form onSubmit={submit} className="w-full max-w-sm space-y-5" data-testid="reset-form">
        <h1 className="font-heading text-2xl font-bold text-slate-900">Atur Ulang Kata Sandi</h1>
        <div className="space-y-2">
          <Label htmlFor="password">Kata Sandi Baru</Label>
          <Input id="password" type="password" value={password} data-testid="reset-password"
            onChange={(e) => setPassword(e.target.value)} required minLength={6} />
        </div>
        <Button type="submit" className="w-full bg-blue-800 hover:bg-blue-900" data-testid="reset-submit">
          Simpan Kata Sandi
        </Button>
        <Link to="/login" className="block text-center text-sm text-blue-700 hover:underline">
          Kembali ke halaman masuk
        </Link>
      </form>
    </div>
  );
}
